import type { Drug } from "../types";

export const phenazoneLidocaineEarDropsDrug: Drug = {
  id: "phenazone_lidocaine_ear_drops",
  name: "Phenazone 40mg/g with lidocaine 10mg/g ear drops",
  drugClass: "analgesic_topical_ear",
  route: "otic",
  brandName: "Otigo®",
  administrationNote:
    "Warm bottle in hand for 1-2 minutes before use. Tilt head sideways and instil drops into the ear canal.",
  antidopingNote:
    "Individuals subject to anti-doping tests should be advised against using Otigo® — may give positive results.",
  formulations: [
    {
      id: "phenaz-lido-15g",
      type: "ear_drops",
      bottleSize: 15,
      bottleSizeUnit: "g",
      brandExample: "Otigo",
      prescribedItemId: "9cf790ad-7bf6-4add-b836-7b70d1b7b862",
    },
  ],
};
